import EmployerLayout from 'components/layouts/employer';
import TeacherLayout from 'components/layouts/teacher';
import React from 'react';
import { useSelector } from 'react-redux';
import LoggedOutLayout from './loggedOut';

const CommonLayout = ({ children }) => {
  const { loaded, currentEmployerProfile, currentUserProfile, currentAccount, employerProfiles } =
    useSelector(({ employer, account, currentUserProfile }) => {
      return {
        currentAccount: account.currentAccount,
        loaded: account.loaded,
        currentEmployerProfile: employer.currentEmployerProfile,
        currentUserProfile: currentUserProfile.currentUserProfile,
        employerProfiles: employer.employerProfiles,
      };
    });

  if (loaded) {
    if (currentEmployerProfile?.id) return <EmployerLayout>{children}</EmployerLayout>;
    if (currentUserProfile?.id) return <TeacherLayout>{children}</TeacherLayout>;
  }

  return <LoggedOutLayout>{children}</LoggedOutLayout>;
};

export default CommonLayout;
